export const featurePaths = {
    CustomsList: "/CustomsList",
} as const;

export const apiPaths = {} as const;
